import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ShimmerComponent } from './shimmer.component';

@NgModule({
  declarations: [ShimmerComponent],
  imports: [CommonModule],
  exports: [ShimmerComponent],
})
export class ShimmerModule {}
